module.exports = "/assets/dba10ae5ba469e3b4af3dac8dbc15fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/premier-inn-icon.png
// module id = 608
// module chunks = 0